import React from 'react';
import { useIntl } from 'react-intl';
import { useFormContext, Controller } from 'react-hook-form';
import { CenteredFlexBox } from '../../../../Components/FlexBox';
import FormSelect from '../../../../Components/Form/FormSelect';
import Select from '../../../../Components/Inputs/Select';
import DbeDatePicker from '../../../../Components/Inputs/DbeDatePicker';
import { TIME_SLOTS } from '../../Utils/getTimeSlots';

/** The date, time slot and assignee of a scheduled activity, fed by useScheduleFields. */
const ScheduleFields = function ScheduleFields({
  date,
  timeSlot,
  operators = [],
  onChangeDate,
  onChangeTimeSlot,
  assigneeDefault = '',
}) {
  const intl = useIntl();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {/* Hidden field to track scheduledOn for form validation */}
      <Controller
        name="scheduledOn"
        control={control}
        rules={{
          required: intl.messages.REQUIRED_FIELD || 'This field is required',
        }}
        render={({ field }) => (
          <input type="hidden" {...field} value={field.value || ''} />
        )}
      />
      <CenteredFlexBox gap="8px">
        <DbeDatePicker
          required
          width="50%"
          minDate={new Date()}
          label={intl.messages.DATE}
          date={date}
          onChange={(newDate) => {
            onChangeDate(newDate);
          }}
          variant="outlined"
        />
        <Select
          required
          width="50%"
          error={errors?.scheduledOn}
          label="TIME_SLOT"
          options={TIME_SLOTS.map((time) => ({
            label: time,
            value: time,
            disabled:
              new Date(
                date?.getFullYear(),
                date?.getMonth(),
                date?.getDate(),
                parseInt(time.substring(0, 2), 10),
                parseInt(time.substring(3, 5), 10)
              )?.getTime() < new Date().getTime(), //disables all the time slots smaller than current time (current time slot included)
          }))}
          value={timeSlot}
          onChange={(newValue) => onChangeTimeSlot(newValue)}
        />
      </CenteredFlexBox>
      <FormSelect
        name="assignee"
        error={errors?.assignee}
        defaultValue={assigneeDefault}
        options={[
          {
            label: intl.messages.ALL,
            value: 'ALL',
          },
          ...operators,
        ]}
        required
        noHelper
      />
    </>
  );
};

export default ScheduleFields;
